module.exports = __webpack_public_path__ + "img/zip.ded51c98.svg";